export default class Argument {
  constructor(data) {
    for (let i in data) {
      this[i] = data[i];
    }

    this.commentsExpanded = [];
  }

  commentsRemainedCount() {
    return this.comments.length - this.commentsExpanded.length;
  }

  commentsPageToLoadNext() {
    return Math.floor(this.commentsExpanded.length / 5) + 1;
  }
}
